<template>
<div>
    <Breadcrumbs main="Admin" submain="Subscription" title="Affiliate Referral User" />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body">
                        <b-row class="d-flex justify-content-center align-items-center">
                            <b-col xl="6" class="d-flex flex-wrap" style="gap: 20px">
                                <b-input-group style="width: 340px;">
                                    <b-form-input v-model="search" @keyup="searchUsers" placeholder="Type to Search"></b-form-input>
                                    <b-input-group-append>
                                        <b-button @click="clearSearch">Clear</b-button>
                                    </b-input-group-append>
                                </b-input-group>
                            </b-col> 

                            <b-col xl="6">
                                <b-form-group label-cols="2" label="Per page" class="mb-0 datatable-select">
                                    <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <div v-if="!loading && !error && !loadingPage">
                            <div class="table-responsive datatable-vue mt-4">
                                <b-table :items="subscriber_list" :fields="tablefields" :per-page="perPage" show-empty stacked="md">
                                    <template #cell(index)="data">
                                        {{ (currentPage - 1) * perPage + data.index + 1 }}
                                    </template>

                                    <template #cell(user)="row">
                                        <div style="display: flex; flex-direction: column; gap: 4px;">
                                            <h7>{{ row.item.user_name }}</h7>
                                            <b-badge style="font-size: 13px; max-width: fit-content;">{{ row.item.user_email }}</b-badge>
                                        </div>
                                    </template>

                                    <template #cell(affiliate_code)="row">
                                        <b-badge style="font-size: 13px; max-width: fit-content;" variant="primary">{{ row.item.affiliate_code }}</b-badge>
                                    </template>

                                    <template #cell(updated_at)="row">
                                        <h7 v-if="row.item.updated_at">{{ formatDate(row.item.updated_at).date }} <br> {{ formatDate(row.item.updated_at).time }}</h7>
                                    </template>
                                </b-table>
                            </div>
                        </div>

                        <div v-else>
                            <loader />
                        </div>

                        <b-row class="mt-3">
                            <b-col xl="12" class="d-flex flex-wrap justify-content-start align-items-center" style="gap: 8px;">
                                <span>
                                    <!-- First Page Button (<<) -->
                                    <button class="pg-button" :disabled="currentPage === 1" @click="goToPage(1)">
                                        <b-icon icon="chevron-double-left"></b-icon>
                                    </button>
    
                                    <!-- Previous Page Button (<) -->
    
                                    <button class="pg-button ml-2" :disabled="currentPage === 1" @click="goToPage(currentPage - 1)">
                                        <b-icon icon="chevron-left"></b-icon>
                                    </button>
                                </span>

                                <!-- Page Number Display (Page X of Y) -->
                                <span class="align-self-center">
                                    <span class="align-self-center">
                                        <span class="d-flex align-items-center" style="gap: 6px;">
                                            <span>Page</span>
                                            <b-form-input v-model="currentPage" style="box-shadow: none; width: 54px; text-align: center;" @blur="validatePage" @keydown.enter="validatePage" :disabled="totalPages <= 1"></b-form-input>
                                            <span>of {{ totalPages }}</span>
                                        </span>
                                    </span>
                                </span>

                                <span>
                                    <!-- Next Page Button (>) -->
                                    <button class="mr-2 pg-button" :disabled="currentPage === totalPages" @click="goToPage(currentPage + 1)">
                                        <b-icon icon="chevron-right"></b-icon>
                                    </button>
    
                                    <!-- Last Page Button (>>) -->
                                    <button class="pg-button" :disabled="currentPage === totalPages" @click="goToPage(totalPages)">
                                        <b-icon icon="chevron-double-right"></b-icon>
                                    </button>
                                </span>
                            </b-col>
                        </b-row>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Container-fluid Ends-->
</div>
</template>

<script>
import { mapState } from 'vuex';
import { myHost } from '../../../_helpers/host';
import loader from '../loader/loader.vue';
import Multiselect from 'vue-multiselect';
import 'sweetalert2/src/sweetalert2.scss';

export default {
    components: {
        loader,
        Multiselect
    },

    data() {
        return {
            host: myHost.host,
            selected: [],
            isDisabled: false,
            subscriber: {

            },
            tablefields: [{
                    key: 'index',
                    label: '#'
                },
                {
                    key: 'user',
                    label: 'User',
                    sortable: false
                },
                {
                    key: 'user_id',
                    label: 'User ID',
                    sortable: false
                },
                {
                    key: 'affiliate_name',
                    label: 'Affiliate',
                    sortable: false
                },
                {
                    key: 'affiliate_code',
                    label: 'Referral Code',
                    sortable: false
                },
                {
                    key: 'rewarded_coins',
                    label: 'Rewarded Coins',
                    sortable: true
                },
                {
                    key: 'updated_at',
                    label: 'Updated At',
                    sortable: true
                }
            ],

            initialLoad: true,
            filterShow: false,
            search: null,
            totalRows: 1,
            currentPage: 1,
            perPage: 25,
            loadingPage: false,
            pageOptions: [25, 50, 100]
        };
    },

    computed: {
        ...mapState({
            subscriber_list: state => state.referral.subscriber,
            loading: state => state.referral.subscriberLoading,
            error: state => state.referral.subscriberError,
            count: state => state.referral.subscriber_count
        }),

        totalPages() {
            if (typeof this.totalRows === 'number' && !isNaN(this.totalRows) && this.totalRows > 0) {
                return Math.ceil(this.totalRows / this.perPage);
            }
            return 1; // Default to 1 if totalRows is invalid
        }
    },

    watch: {
        currentPage(newCurrentPage) {
            if (!this.initialLoad) {
                if (this.currentPage === null || this.currentPage === '') {
                    this.loadingPage = true
                }
                
                this.$router.replace({
                    path: '/subscription/affiliate-referral-user/list',
                    query: {
                        page: newCurrentPage,
                        perPage: this.perPage
                    }
                });

                this.currentPage = newCurrentPage
                this.$store.dispatch("referral/fetchReferralUser", {
                    perPage: this.perPage,
                    currentPage: newCurrentPage
                }).then(() => {
                    this.totalRows = this.count;
                    this.initialLoad = false
                });
            }
        },

        perPage(newperPage) {
            if (!this.initialLoad) {
                this.$router.replace({
                    path: '/subscription/affiliate-referral-user/list',
                    query: {
                        page: newCurrentPage,
                        perPage: this.perPage
                    }
                });

                this.perPage = newperPage
                this.$store.dispatch("referral/fetchReferralUser", {
                    perPage: newperPage,
                    currentPage: this.currentPage
                }).then(() => {
                    this.totalRows = this.count;
                    this.initialLoad = false
                });
            }
        }
    },

    mounted() {
        if (this.initialLoad) {
            if (!this.$route.query.page || !this.$route.query.perPage) {
                this.$router.replace({
                    path: this.$route.path,
                    query: {
                        page: this.currentPage,
                        perPage: this.perPage
                    }
                }).catch(err => {
                    if (err.name !== 'NavigationDuplicated') {
                        throw err;
                    }
                });
                this.fetchInitial();
            } else {
                this.currentPage = parseInt(this.$route.query.page);
                this.perPage = parseInt(this.$route.query.perPage);
                this.fetchInitial();
            }
        }
    },

    methods: {
        validatePage() {
            this.loadingPage = true;
            const totalPages = this.totalPages;
            
            if (!this.currentPage || isNaN(this.currentPage) || this.currentPage < 1) {
                this.currentPage = 1;
            } else if (Number(this.currentPage) > totalPages) {
                this.currentPage = totalPages; // Set to last valid page
            }

            this.loadingPage = false;
        },

        goToPage(page) {
            if (page < 1 || page > this.totalPages) return;
            this.currentPage = page;
        },

        formatDate(dateStr) {
            if (!dateStr) return ''

            const date = new Date(dateStr)

            const day = date.getDate()
            const month = date.toLocaleString('default', {
                month: 'long'
            })
            const year = date.getFullYear()

            const hours = date.getHours()
            const minutes = date.getMinutes().toString().padStart(2, '0')
            const ampm = hours >= 12 ? 'PM' : 'AM'
            const hour12 = hours % 12 || 12

            const getOrdinal = (n) => {
                const s = ['th', 'st', 'nd', 'rd']
                const v = n % 100
                return s[(v - 20) % 10] || s[v] || s[0]
            }

            return {
                date: `${day}${getOrdinal(day)} ${month}, ${year}`,
                time: `${hour12}:${minutes} ${ampm}`
            }
        },

        fetchInitial() {
            this.$store.dispatch("referral/fetchReferralUser", {
                perPage: this.$route.query.perPage,
                currentPage: this.$route.query.page
            }).then(() => {
                this.totalRows = this.count;
                this.initialLoad = false;
            });
        },

        searchUsers() {
            if (this.search && this.search.trim() !== '' && this.search.length >= 2) {
                this.$store.dispatch("referral/fetchReferralUser", {
                    search: this.search,
                    perPage: this.$route.query.perPage,
                    currentPage: this.$route.query.page
                }).then(() => {
                    this.totalRows = this.count;
                    this.initialLoad = false;
                });
            }
        },

        clearSearch() {
            this.search = null;
            this.fetchInitial();
        }
    }
};
</script>

<style scoped>
.table-danger {
    background-color: #f8d7da !important;
    color: #721c24 !important;
}
</style>
